"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dialog = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const app_1 = require("app");
const body_scroll_lock_1 = require("body-scroll-lock");
const React = require("react");
const MosaicIcon_1 = require("Views/Shared/Components/MosaicIcon");
const popup_1 = require("./popup");
const types_1 = require("./types");
const modalDialogSelector = '[role="dialog"].popup';
const focusLockWhiteList = (el) => !(el.getAttribute('role') === 'dialog' && el.tabIndex === -1);
class Dialog extends React.Component {
    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.reactDOMRenderId && nextProps.reactDOMRenderId !== prevState.reactDOMRenderId) {
            return {
                reactDOMRenderId: nextProps.reactDOMRenderId,
                show: nextProps.isOpen,
            };
        }
        else if (!nextProps.reactDOMRenderId && nextProps.isOpen !== prevState.show) {
            return {
                show: nextProps.isOpen,
            };
        }
        return null;
    }
    constructor(props) {
        super(props);
        this.onCookiesPopupStateChanged = (event) => {
            this.setState({
                lockFocus: !event.detail,
            });
        };
        this.onModalClose = () => {
            var _a, _b;
            const { onClose } = this.props;
            if (onClose) {
                onClose();
            }
            this.setState({ show: false });
            (_b = (_a = this.state) === null || _a === void 0 ? void 0 : _a.resizeObserver) === null || _b === void 0 ? void 0 : _b.disconnect();
        };
        this.onModalExited = () => {
            const { onModalExited } = this.props;
            const modalDialog = document.querySelector(modalDialogSelector);
            (0, body_scroll_lock_1.enableBodyScroll)(modalDialog);
            app_1.overlayService.removeScrollBarPlaceholder();
            if (onModalExited) {
                onModalExited();
            }
        };
        this.onModalShow = () => {
            const modalDialog = document.querySelector(modalDialogSelector);
            (0, body_scroll_lock_1.disableBodyScroll)(modalDialog);
            app_1.overlayService.addScrollBarPlaceholder();
        };
        this.state = {
            show: props.isOpen,
            reactDOMRenderId: props.reactDOMRenderId || null,
            lockFocus: true,
            resizeObserver: null,
        };
    }
    componentDidMount() {
        window.addEventListener('CookiesPopupStateChanged', this.onCookiesPopupStateChanged);
    }
    componentWillUnmount() {
        window.removeEventListener('click', this.onCookiesPopupStateChanged);
    }
    render() {
        const { title, children, classes, keyboard, backdrop, popupAriaLabel, addClosePropertyForChildren = true, popupType = types_1.PopupType.DEFAULT, } = this.props;
        const { lockFocus, show } = this.state;
        const mediaStyles = popupType === types_1.PopupType.MEDIA ? 'max-md:h-[90%] max-md:flex-col max-md:justify-center' : '';
        const childrenWithProps = addClosePropertyForChildren
            ? React.Children.map(children, child => React.cloneElement(child, { close: this.onModalClose }))
            : children;
        return ((0, jsx_runtime_1.jsxs)(popup_1.Popup, { isOpened: show, onShow: this.onModalShow, onClose: this.onModalClose, onExited: this.onModalExited, isKeyboard: keyboard, backdrop: backdrop, className: `${classes} popup`, popupAriaLabel: popupAriaLabel ? popupAriaLabel : title, "aria-describedby": "dialog-body", focusLockWhiteList: focusLockWhiteList, isCloseButton: false, disableFocusLock: !lockFocus, popupType: popupType, children: [(0, jsx_runtime_1.jsxs)("div", { className: `popup-header relative ${types_1.PopupHeaderWrapper[popupType]} `, children: [(0, jsx_runtime_1.jsx)("button", { className: `close ${types_1.closeBtn[popupType]}`, onClick: this.onModalClose, children: (0, jsx_runtime_1.jsx)(MosaicIcon_1.MosaicIcon, { name: "close-outline", className: `${types_1.closeBtnIcon[popupType]} ${types_1.closeBtnPosition[popupType]}` }) }), (0, jsx_runtime_1.jsx)("h4", { className: types_1.PopupHeader[popupType], children: title || '' })] }), (0, jsx_runtime_1.jsxs)("div", { id: "dialog-body", className: `${types_1.PopupBody[popupType]} ${mediaStyles}`, children: ["  ", childrenWithProps, " "] }), (0, jsx_runtime_1.jsx)("div", { className: "screen-reader-only inner-dialog-accessible-description", tabIndex: -1, "aria-label": title, "aria-describedby": "dialog-body" })] }));
    }
}
exports.Dialog = Dialog;
